var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import WarehouseService from '../../../api/WarehouseService';
import AreaShop from "@/components/AreaShop";
var initFormData = {
    order_status: [0, 1],
    keyword_type: 1,
    s_time: new Date(Date.now() - 30 * 24 * 3600 * 1000),
    e_time: new Date(),
    keyword_depot: 1,
    depot_ids: []
};
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.type = [
            {
                id: 1,
                label: "单号"
            },
            {
                id: 2,
                label: "货品"
            }
        ];
        _this.options = [
            {
                id: -1,
                label: "全部状态"
            },
            {
                id: 0,
                label: "待审核"
            },
            {
                id: 1,
                label: "已审核"
            },
            {
                id: 6,
                label: "已废弃"
            },
        ];
        _this.isMoreSearch = false;
        _this.shipStatusList = [
            { name: "全部", value: "-1" },
            { name: "待发货", value: 1 },
            { name: "部分发货", value: 2 }
        ];
        _this.keywordDepots = [
            { name: "调出仓库", value: 1 },
            { name: "调入仓库", value: 2 },
        ];
        _this.treeData = [];
        return _this;
    }
    BillHeader.prototype.created = function () {
        this.service = WarehouseService.getInstance();
    };
    BillHeader.prototype.mounted = function () {
        this.getOrgandepotOptions();
        this.search();
    };
    BillHeader.prototype.search = function () {
        this.$emit('search', __assign({}, this.formData));
    };
    BillHeader.prototype.getOrgandepotOptions = function () {
        var _this = this;
        this.service.getOrgandepotOptions().then(function (res) {
            if (res.data.success) {
                var data = res.data.data.map(function (item) {
                    var children = item.children && item.children.length > 0 && item.children.map(function (child) {
                        return __assign({}, child);
                    });
                    return __assign({}, item, { depot_id: item.organ_id + '_organ_id', depot_name: item.organ_name, children: children });
                });
                _this.treeData = data;
            }
        });
    };
    BillHeader.prototype.reset = function () {
        this.formData = __assign({}, initFormData);
    };
    BillHeader.prototype.moreSearchComShow = function () {
        this.isMoreSearch = true;
    };
    BillHeader.prototype.moreSearchComHide = function () {
        this.isMoreSearch = false;
    };
    BillHeader.prototype.normalizer = function (node) {
        return {
            id: node.depot_id,
            label: node.depot_name,
            children: node.children,
        };
    };
    BillHeader = __decorate([
        Component({
            components: {
                "areaShop": AreaShop
            }
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
